import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type SliderDotsClasses =
  | 'container'
  | 'interiorImageContainer'
  | 'sliderDots'
  | 'selectedDot'
  | 'interiorSelectedDot'
  | 'disabledDots';

const sliderDotsStyles = makeStyles<ISpcTheme, SliderDotsClasses>(
  ({ palette, spacing, typography, breakpoints }) => ({
    container: {
      marginTop: spacing(2),
    },
    interiorImageContainer: {
      position: 'relative',
      top: '-120px',
      marginTop: 0,

      [breakpoints.down('xs')]: {
        top: '-50px',
      },
    },
    sliderDots: {
      '& svg': {
        fontSize: typography.fontXXS,
        color: palette.primaryDisabled.main,
        backgroundColor: palette.primaryDisabled.main,
        borderRadius: '50%',
      },
    },
    selectedDot: {
      '& svg': {
        fontSize: typography.fontMD,
        color: palette.secondary.main,
        backgroundColor: palette.secondary.main,
        [breakpoints.down('xs')]: {
          fontSize: typography.fontSM,
        },
      },
    },
    interiorSelectedDot: {
      '& svg': {
        color: palette.common.white,
        backgroundColor: palette.common.white,
      },
    },
    disabledDots: {
      '& svg': {
        color: palette.primaryDisabled.main,
        backgroundColor: palette.primaryDisabled.main,
      },
    },
  }),
  { name: 'Customise_SliderDotsStyles' },
);

export default sliderDotsStyles;
